import { useCallback, useContext, useEffect } from "react";
import SearchTermsBox from "./SearchTermsBox";
import { ImCross } from "react-icons/im";
import SearchIcon from "../icons/SearchIcon";
import useScreenSize from "@/hooks/global/useDisplay";
import { AppContext } from "@/contexts/appContexts";

const SearchBox = ({
  locale,
  handleInputFocus,
  openSearchPopupTerms,
  openSearchTermsRef,
  redirectToSearch,
  setShowSearchBoxModal,
  setOpenSearchPopupTerms,
  setInputValueHandler,
  inputValue,
  products,
  suggestions,
  handleSearch,
  queryID,
  searchInputRef,
  inputId,
}) => {
  const handleInputChange = (event) => {
    const searchValue = event.currentTarget.value;
    setInputValueHandler(searchValue);
  };

  const { screenSize } = useScreenSize();
  const { savedSearchWords } = useContext(AppContext);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim().length >= 2) {
      redirectToSearch(inputValue);
      setShowSearchBoxModal(false);
      setOpenSearchPopupTerms(false);
      event.target.blur();
    }
  };

  const handleClearSearch = useCallback(() => {
    setInputValueHandler("");
    setShowSearchBoxModal(false);
    setOpenSearchPopupTerms(false);
  }, [setInputValueHandler, setOpenSearchPopupTerms, setShowSearchBoxModal]);

  const showSearchTermsBox =
    (inputValue && products?.length > 0) || savedSearchWords?.length > 0;

  useEffect(() => {
    if (showSearchTermsBox && screenSize === "sm" && openSearchPopupTerms) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  }, [showSearchTermsBox, screenSize, openSearchPopupTerms]);

  return (
    <>
      <div className="relative  min-h-[30px] md:min-h-[46px] flex items-center justify-center">
        <input
          id={inputId}
          ref={searchInputRef}
          placeholder={
            screenSize === "sm" && locale === "ar"
              ? "ابحث عن منتج"
              : screenSize === "sm" && locale === "en"
              ? "Search for products"
              : locale === "ar"
              ? "ما الذي يمكننا مساعدتك في العثور عليه اليوم؟"
              : "What can we help you find today?"
          }
          className="w-full px-3 text-sm rounded-lg outline-none placeholder:text-sm"
          autoComplete="off"
          value={inputValue}
          autoFocus={false}
          onClick={handleInputFocus}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <div
          className={`${
            inputValue ? "cursor-pointer" : "pointer-events-none"
          } absolute inset-y-0 ${
            locale === "en" ? "right-0" : "left-0"
          } flex items-center px-3`}
        >
          {!inputValue ? (
            <SearchIcon color={screenSize === "sm" ? "gray" : "#D9232E"} />
          ) : (
            <ImCross
              onClick={handleClearSearch}
              className="absolute text-gray-400 cursor-pointer size-3 ltr:right-3 rtl:left-3"
              aria-label="Clear search"
            />
          )}
        </div>
      </div>

      {openSearchPopupTerms && (
        <SearchTermsBox
          inputValue={inputValue}
          openSearchTermsRef={openSearchTermsRef}
          products={products}
          suggestions={suggestions}
          redirectToSearch={redirectToSearch}
          clearSearch={handleClearSearch}
          setInputValue={setInputValueHandler}
          handleSearch={handleSearch}
          queryID={queryID}
        />
      )}
    </>
  );
};

export default SearchBox;
